import { EventHelper } from "../../../../../../UI/UI.BaseControls/Helpers/EventHelper";
import { DropDownMenuItem } from "../../../../../../UI/UI.Controls/DropDownMenu/DropDownMenuItem";
import { registerCustomElement } from "../../../../../../UI/UI.ElementarControls/Utils/CustomElementUtils";

export class DropDownTextAreaItem extends DropDownMenuItem {
    //#region Fields
    public isClickable: boolean = false;
    protected override _textElement: HTMLTextAreaElement;
    //#endregion Fields

    //#region Properties
    public get text(): string {
        return this._textElement.value;
    }
    //#endregion Properties

    protected override _constructor(): void {
        super._constructor();
    }

    //#region Methods
    protected override connectedCallback(): void {
        super.connectedCallback();
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "textarea");

        this._textElement = document.createElement("textarea");

        this.appendChild(this._textElement);
    }

    protected override _createCaptionElement(): void {
        // Nemá se vytvářet nic, ani z předka
    }

    protected override _setListener(): void {
        this.registerEventListener("click", (event: MouseEvent) => {
            if (event.button === 0) {
                EventHelper.stopImmediatePropagation(event);
            }
        });

        this._textElement.addEventListener("focus", () => {
            this._textElement.classList.add("focused");
        });

        this._textElement.addEventListener("blur", () => {
            this._textElement.classList.remove("focused");
        });

        this._textElement.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault(); // Nechceme reagovat
            } else if (e.key === "Escape") {
                e.stopPropagation(); // Zabrání zavření
            }
        });

        this._textElement.addEventListener("keyup", (e: KeyboardEvent) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                this.callEvent("ConfirmInput");
            }
        });
    }

    public override focus(): void {
        this._textElement.focus();
    }

    public override dispose(): void {
        super.dispose();
    }
    //#endregion Methods
}

registerCustomElement("tsc-DropDownTextAreaItem", DropDownTextAreaItem);
